// extracted by mini-css-extract-plugin
export default {"wrapper":"ComicsSuggestions_wrapper__diaXI","title":"ComicsSuggestions_title__UUbyW","categorys":"ComicsSuggestions_categorys__BpkB-","active":"ComicsSuggestions_active__w1VGX"};